import { BsImageFill, BsMusicNoteBeamed, BsCameraVideoFill, FaFile } from '../styles/Icons';

export const categoryList = [
  {
    title: "Images",
    numberOfFiles: 437,
    icon: BsImageFill,
    colorPrimary: 'red'
  },
   {
    title: "Documents",
    numberOfFiles: 212,
    icon: FaFile,
    colorPrimary: 'blue' 
   },
 {
   title: "Audios",
   numberOfFiles: 98,
   icon: BsMusicNoteBeamed,
   colorPrimary: 'yellow'
 },
 {
   title: "Videos",
   numberOfFiles: 560,
   icon: BsCameraVideoFill,
   colorPrimary: 'green' 
 },
]